/**
 * Tabs that can create an accordion for mobile.
 */
/*eslint-disable*/
jQuery(document).ready($ => {
	$(".em-tabs-wrap").each(function(a) {
		var emStartTab = $(this)
			.find("> .em-tabs-title-list .em-tab-title-active")
			.attr("data-tab");
		var emTabsList = $(this)
			.find("> .em-tabs-title-list")
			.attr({
				role: "tablist"
			});
		$(this)
			.find("> .em-tabs-content-wrap > .em-tab-inner-content")
			.attr({
				role: "tabpanel",
				"aria-hidden": "true"
			});
		$(this)
			.find(".em-tabs-content-wrap > .em-inner-tab-" + emStartTab)
			.attr("aria-hidden", "false");
		$(this)
			.find("> .em-tabs-title-list li:not(.em-tab-title-active) a")
			.each(function() {
				$(this)
					.attr({
						role: "tab",
						"aria-selected": "false",
						tabindex: "-1"
					})
					.parent()
					.attr("role", "presentation");
			});
		$(this)
			.find("> .em-tabs-title-list li.em-tab-title-active a")
			.attr({
				role: "tab",
				"aria-selected": "true",
				tabindex: "0"
			})
			.parent()
			.attr("role", "presentation");
		$(emTabsList).delegate("a", "keydown", function(e) {
			switch (e.which) {
				case 37:
				case 38:
					if (
						$(this)
							.parent()
							.prev().length != 0
					) {
						$(this)
							.parent()
							.prev()
							.find("> a")
							.click();
					} else {
						$(emTabsList)
							.find("li:last > a")
							.click();
					}
					break;
				case 39:
				case 40:
					if (
						$(this)
							.parent()
							.next().length != 0
					) {
						$(this)
							.parent()
							.next()
							.find("> a")
							.click();
					} else {
						$(emTabsList)
							.find("li:first > a")
							.click();
					}
					break;
			}
		});
	});
	$(".em-tabs-title-list li a").click(function(e) {
		e.preventDefault();
		var tabId = $(this).attr("data-tab");

		$(this)
			.closest(".em-tabs-title-list")
			.find(".em-tab-title-active")
			.addClass("em-tab-title-inactive")
			.removeClass("em-tab-title-active")
			.find("a.em-tab-title")
			.attr({
				tabindex: "-1",
				"aria-selected": "false"
			});
		$(this)
			.closest(".em-tabs-wrap")
			.removeClass(function(index, className) {
				return (className.match(/\bem-active-tab-\S+/g) || []).join(" ");
			})
			.addClass("em-active-tab-" + tabId);
		$(this)
			.parent("li")
			.addClass("em-tab-title-active")
			.removeClass("em-tab-title-inactive");
		$(this)
			.attr({
				tabindex: "0",
				"aria-selected": "true"
			})
			.focus();
		$(this)
			.closest(".em-tabs-wrap")
			.find(
				".em-tabs-content-wrap > .em-tab-inner-content:not(.em-inner-tab-" +
					tabId +
					")"
			)
			.attr("aria-hidden", "true");
		$(this)
			.closest(".em-tabs-wrap")
			.find(".em-tabs-content-wrap > .em-inner-tab-" + tabId)
			.attr("aria-hidden", "false");
		$(this)
			.closest(".em-tabs-wrap")
			.find(
				".em-tabs-content-wrap > .em-tabs-accordion-title:not(.em-tabs-accordion-title-" +
					tabId +
					")"
			)
			.addClass("em-tab-title-inactive")
			.removeClass("em-tab-title-active")
			.attr({
				tabindex: "-1",
				"aria-selected": "false"
			});
		$(this)
			.closest(".em-tabs-wrap")
			.find(
				".em-tabs-content-wrap > .em-tabs-accordion-title.em-tabs-accordion-title-" +
					tabId
			)
			.addClass("em-tab-title-active")
			.removeClass("em-tab-title-inactive")
			.attr({
				tabindex: "0",
				"aria-selected": "true"
			});
	});
	$(".em-create-accordion")
		.find("> .em-tabs-title-list .em-title-item")
		.each(function() {
			var tabId = $(this)
				.find("a")
				.attr("data-tab");
			var activeclass;
			var iconclass;
			var iconsideclass;
			if ($(this).hasClass("em-tab-title-active")) {
				activeclass = "em-tab-title-active";
			} else {
				activeclass = "em-tab-title-inactive";
			}
			if ($(this).hasClass("em-tabs-svg-show-only")) {
				iconclass = "em-tabs-svg-show-only";
			} else {
				iconclass = "em-tabs-svg-show-always";
			}
			if ($(this).hasClass("em-tabs-icon-side-top")) {
				iconsideclass = "em-tabs-icon-side-top";
			} else {
				iconsideclass = "";
			}
			$(this)
				.closest(".em-tabs-wrap")
				.find("> .em-tabs-content-wrap > .em-inner-tab-" + tabId)
				.before(
					'<div class="em-tabs-accordion-title em-tabs-accordion-title-' +
						tabId +
						" " +
						activeclass +
						" " +
						iconclass +
						" " +
						iconsideclass +
						'">' +
						$(this).html() +
						"</div>"
				);
		});
	$(".em-tabs-accordion-title a").click(function(e) {
		e.preventDefault();
		var tabId = $(this).attr("data-tab");
		if (
			$(this)
				.parent(".em-tabs-accordion-title")
				.hasClass("em-tab-title-active")
		) {
			$(this)
				.closest(".em-tabs-wrap")
				.removeClass("em-active-tab-" + tabId);
			$(this)
				.parent(".em-tabs-accordion-title")
				.removeClass("em-tab-title-active")
				.addClass("em-tab-title-inactive");
		} else {
			// $( this ).closest( '.em-tabs-wrap' ).find( '.em-tab-title-active' )
			// 	.addClass( 'em-tab-title-inactive' )
			// 	.removeClass( 'em-tab-title-active' );
			// $( this ).closest( '.em-tabs-wrap' ).removeClass( function( index, className ) {
			// 	return ( className.match( /\bem-active-tab-\S+/g ) || [] ).join( ' ' );
			// } ).addClass( 'em-active-tab-' + tabId );
			$(this)
				.closest(".em-tabs-wrap")
				.addClass("em-active-tab-" + tabId);
			//$( this ).closest( '.em-tabs-wrap' ).find( 'ul .em-title-item-' + tabId ).addClass( 'em-tab-title-active' ).removeClass( 'em-tab-title-inactive' );
			$(this)
				.parent(".em-tabs-accordion-title")
				.addClass("em-tab-title-active")
				.removeClass("em-tab-title-inactive");
		}
	});
	if (window.location.hash != "") {
		var matches = window.location.hash.match(/\btab-\S+/g);
		if (matches !== null && matches.length === 1) {
			var tabid = matches[0];
			var tabnumber = $("#" + tabid + " a").attr("data-tab");
			$("#" + tabid)
				.closest(".em-tabs-title-list")
				.find(".em-tab-title-active")
				.addClass("em-tab-title-inactive")
				.removeClass("em-tab-title-active");
			$("#" + tabid)
				.closest(".em-tabs-wrap")
				.removeClass(function(index, className) {
					return (className.match(/\bem-active-tab-\S+/g) || []).join(" ");
				})
				.addClass("em-active-tab-" + tabnumber);
			$("#" + tabid).addClass("em-tab-title-active");
			$("#" + tabid)
				.closest(".em-tabs-wrap")
				.find(".em-tabs-accordion-title.em-tabs-accordion-title-" + tabid)
				.addClass("em-tab-title-active")
				.removeClass("em-tab-title-inactive");
		}
	}
});
/* eslint-enable */
